import React, { useState } from 'react';

const InputCounter = () => {
  const [count, setCount] = useState(0);

  const handleIncrement = () => {
    setCount(count + 1);
  };

  const handleDecrement = () => {
    if (count > 0) {
      setCount(count - 1);
    }
  };

  return (
    <div>
      <button onClick={handleDecrement}>-</button>
      <input value={count}/>
      <button onClick={handleIncrement}>+</button>
    </div>
  );
};

export default InputCounter;